<template>
   <div class="ml20" style="position: relative;">
        <div class="approval-flow-activity-details">
            <div class="history-item">
                <div class="complete-approval-flow-header">
                    <span class="flow-title flex-row a-baseline">
                        <span class="title-nodetail-word-container">审批进度</span>
                        <!-- <button type="button" class="ant-btn ant-btn-text ant-btn-icon-only comment-btn">
                        <i class="icon-e690"></i>
                        </button> -->
                    </span>
                    <div class="title-right">
                        <span v-if="stamp.status == 0" class="status-text">审批中</span>
                        <span v-else-if="stamp.status == 2" class="status-text">审批拒绝</span>
                        <span v-else class="status-text">审批完成</span>
                    </div>
                </div>

                <ul class="time-line ml18">
                    <li class="item-line-item">
                        <div class="item-line-item-content">
                        <div class="item-node-info">
                            <div class="item-line-item-tail" style="top: 3px;"></div>
                            <div class="item-line-item-icon time-icon-activity">
                                <img src="../../../public/images/tongguo.png" style="width:15px;height:15px" />
                            </div>
                            <div class="item-line-item-content-title">
                            <span>提交人</span>
                            <span class="activity-result" style="color: rgb(153, 153, 153);"></span>
                            </div>
                        </div>
                        <div class="activity-detail">
                            <div class="item-line-item-tail"></div>
                            <div>
                            <div class="item-line-item-content-detail">
                                <div class="flex-row a-strech">
                                    <div class="item-portraits">
                                        <div class="common-child-view-img" style="width: 32px;">
                                        <span>
                                            <a>
                                                <div class="mini-card-avatar size-30-x-30 avatar-initial-1" :title="stamp.create_person" style="margin-left: 0px; position: absolute; z-index: 0;">
                                                    <span class="avatar-content">{{stamp.create_person.charAt(stamp.create_person.length - 1)}}</span>
                                                </div>
                                            </a>
                                        </span>
                                        </div>
                                    </div>
                                    <div class="flex-1 flex-column j-center detail-action">
                                        <div>
                                        <span class="assignee-name">{{ stamp.create_person }}</span>
                                        <span class="action">创建了审批</span>
                                        </div>
                                        <span class="happen-time">{{stamp.time}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="activity-main-cc-list activity-main-cc-list-none"></div>
                            </div>
                        </div>
                        </div>
                    </li>
                    <li class="item-line-item" v-for="item in approvalDetail" :key="item.uid">
                        <div class="item-line-item-content">
                            <div class="item-node-info">
                                <div class="item-line-item-tail"></div>
                                <div class="item-line-item-icon time-icon-activity">
                                    <img v-if="item.status == 1" src="../../../public/images/tongguo.png" style="width:15px;height:15px" />
                                    <img v-else src="../../../public/images/daishenpi.png" style="width:15px;height:15px" />
                                </div>
                                <div class="item-line-item-content-title">
                                    <span>{{ item.position }}</span>
                                    <span class="activity-type">1人单人审批</span>

                                    <span v-if="item.status == 0" class="activity-result" style="color: rgb(255, 144, 46);">待审批</span>
                                    <span v-else-if="item.status == 2" class="activity-result" style="color: rgb(255, 0, 0);">已拒绝</span>
                                    <span v-else class="activity-result" style="color: rgb(41, 189, 101);">通过</span>
                                </div>
                            </div>
                        </div>
                        <div class="activity-detail mt10 item-line-item-content">
                            <div class="item-line-item-tail item-line-item-none" style=""></div>
                            <div>
                                <div class="item-line-item-content-detail">
                                    <div class="flex-row a-strech">
                                        <div class="flex-1 flex-column j-center detail-action">
                                            <div>
                                                <div class="item-portraits">
                                                    <div class="common-child-view-img" style="width: 32px;">
                                                        <span>
                                                            <a>
                                                                <div class="mini-card-avatar size-30-x-30 avatar-initial-1" :title="item.name" style="margin-left: 0px; position: absolute; z-index: 0;">
                                                                    <span class="avatar-content">{{item.name.charAt(item.name.length - 1)}}</span>
                                                                </div>
                                                            </a>
                                                        </span>
                                                    </div>
                                                </div>
                                                <span class="assignee-name">{{ item.name }}</span>
                                                <span v-if="item.status == 0" class="activity-result" style="color: rgb(255, 144, 46);">待审批</span>
                                                <span v-else-if="item.status == 2" class="activity-result" style="color: rgb(255, 0, 0);">已拒绝</span>
                                                <span v-else class="activity-result" style="color: rgb(41, 189, 101);">通过</span>
                                                <span v-else class="activity-result" style="color: rgb(41, 189, 101);">通过</span>
                                            </div>
                                            <div v-if="item.status != 0" class="fs12 a60">
                                                审批时间： {{ item.process_time }}
                                            </div>
                                            <div v-if="item.remark != null && item.remark != ''">
                                                备注: {{item.remark}}
                                            </div>
                                            <div v-if="stamp.step == item.flow_idx" class="flex">
                                                <div v-if="(approvalForm.id == item.uid)&&(approvalForm.confirm_status == 0)" class="mt10">
                                                    <a-button @click="reject" class="ml20" size="small" style="">
                                                        拒绝
                                                    </a-button>
                                                    <a-button @click="accept" class="ml20" size="small" style="background-color: #fd6363;color: white;">
                                                        同意
                                                    </a-button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <a-modal v-model="accept_visible" width="40%" @ok="confirmAccept" okText="确定" cancelText="取消">
            <div>
                <div>
                    <div>备注</div>
                    <div class="mt10">
                        <a-textarea v-model="message" placeholder="请输入备注" :rows="4" />
                    </div>
                </div>
            </div>
        </a-modal>

        <a-modal v-model="reject_visible" width="40%" @ok="confirmReject" okText="确定" cancelText="取消">
            <div>
                <div>
                    <div>拒审原因</div>
                    <div class="mt10">
                        <a-textarea v-model="message" placeholder="请输入拒审原因" :rows="4" />
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>
<script>

	export default {
        props:{
            approvalDetail:{
                type: Array,
            },
            stamp:{
                type: Object
            },
            approvalForm:{
                type: Object,
            }
        },
		components: {
            
        },
		data() {
			return {
                message:null,
                accept_visible:false,
                reject_visible:false,
			}
		},
        created(){

        },
        methods:{
            async reject() {
                this.message = null
                this.reject_visible = true;
            },
            async confirmReject() {
                if (this.message == null || this.message == "") {
                    this.$message.error('请输入拒审原因');
                    return;
                }
                let rs = await this.$api.rejectFlow(this.stamp.id, this.message);
                if (rs.err == 0) {
                    this.$message.success('操作成功');
                    this.someAction()
                    this.reject_visible = false;
                } else {
                    this.$message.error('操作失败，请重试或联系管理员');
                }
            },
            async accept() {
                // console.log(this.approvalDetail)
                this.message = null
                this.accept_visible = true;
            },
            async confirmAccept() {
                let rs = await this.$api.acceptFlow(this.stamp.id, this.message);
                if (rs.err == 0) {
                    this.$message.success("审批通过")
                    this.someAction()
                    this.accept_visible = false;
                } else if (rs.err == 2) {
                    this.$message.error("操作失败，请重试或联系管理员")
                }
            },
            someAction() { 
                const newParam = {key:1, data:[]};
                this.$emit('update-param', newParam);
            },
        }
	}

</script>

<style>
    .approval-flow-activity-details {
        position: relative;
        background-color: white;
    }
    .complete-approval-flow-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 12px 0px;
        padding-bottom: 10px;
        border-bottom: 1px solid #f0f0f0;
    }
    .flow-title {
        color: #222;
        font-size: 16px;
        line-height: 22px;
        flex: 1 1;
    }
    .title-nodetail-word-container {
        font-weight: bolder;
        margin-right: 10px;
    }
    .flex-row {
        display: flex;
    }
    .item-portraits {
        position: relative;
        display: inline-block;
        width: 32px;
        height: 32px;
        margin-right: 10px;
    }
    .item-line-item-icon {
        position: absolute;
        top: 0px;
        left: -19px; 
    }
    .avatar-initial-1 {
        background-color: #47c2e7;
        font-weight: 400;
    }
    .mini-card-avatar {
        overflow: hidden;
        width: 28px;
        height: 30px;
        clip-path: polygon(45% 1.33975%, 46.5798% 0.60307%, 48.26352% 0.15192%, 50% 0%, 51.73648% 0.15192%, 53.4202% 0.60307%, 55% 1.33975%, 94.64102% 21.33975%, 96.06889% 22.33956%, 97.30146% 23.57212%, 98.30127% 25%, 99.03794% 26.5798%, 99.48909% 28.26352%, 99.64102% 30%, 99.64102% 70%, 99.48909% 71.73648%, 99.03794% 73.4202%, 98.30127% 75%, 97.30146% 76.42788%, 96.06889% 77.66044%, 94.64102% 78.66025%, 55% 98.66025%, 53.4202% 99.39693%, 51.73648% 99.84808%, 50% 100%, 48.26352% 99.84808%, 46.5798% 99.39693%, 45% 98.66025%, 5.35898% 78.66025%, 3.93111% 77.66044%, 2.69854% 76.42788%, 1.69873% 75%, 0.96206% 73.4202%, 0.51091% 71.73648%, 0.35898% 70%, 0.35898% 30%, 0.51091% 28.26352%, 0.96206% 26.5798%, 1.69873% 25%, 2.69854% 23.57212%, 3.93111% 22.33956%, 5.35898% 21.33975%);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .flex-column {
        display: flex;
        flex-direction: column;
    }
    .assignee-name {
        color: #222;
        font-size: 14px;
        line-height: 20px;
    }
    .action {
        margin-left: 5px;
        font-size: 12px;
    }
    .happen-time {
        color: #666;
    }
    .activity-main-cc-list-none {
        background-color: white;
        padding: 0;
    }
    .avatar-content {
        font-size: 12px;
        color: white;
        width: fit-content;
    }
    .common-child-view-img {
        display: inline-block;
        position: relative;
        height: 32px;
        vertical-align: middle;
        font-size: 0;
    }
    .a-baseline {
        align-items: baseline;
    }
    .title-right {
        color: #ff902e;
        font-size: 16px;
        margin-left: 14px;
    }
    .status-text {
        color: #ff902e;
        font-size: 13px;
        margin-left: 2px;
    }
    .time-line {
        box-sizing: border-box;
        line-height: 1.5;
        font-size: 12px;
        list-style: none;
        margin: 0;
        padding: 0 2px 0;
    }
    .item-line-item {
        position: relative;
        margin: 0;
        list-style: none;
    }
    .item-line-item-content {
        /* margin: 0 0 0 18px; */
        word-break: break-word;
    }
    .item-node-info {
        position: relative;
    }
    .item-line-item-tail {
        position: absolute;
        top: 0px;
        left: -12.5px;
        height: 100%;
        border-left: 1px solid #d8d8d8;
    }
    .time-icon-activity {
        top: 0px;
    }
    .item-line-item-content-title {
        color: #222222;
        font-size: 13px;
    }
    .activity-type {
        margin-left: 4px;
        font-size: 12px;
        color: #999;
    }
    .activity-result {
        margin-left: 4px;
    }
    .activity-detail {
        position: relative;
        padding-bottom: 8px;
    }
    .item-line-item-content-detail {
        padding-top: 12px;
        color: #999;
    }

    .common-header {
        position: relative;
        color: #000;
        line-height: 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        width: 100%;
        font-size: 16px;
    }
    .common-title {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        width: unset;
        max-width: 290px;
    }
</style>
